var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    [
      _c(
        "v-dialog",
        { attrs: { "max-width": "1000px", persistent: "", value: true } },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", [
                _c("span", { staticClass: "headline" }, [
                  _vm._v(_vm._s(_vm.$t("travelService.orderHotel")))
                ])
              ]),
              _c(
                "v-card-text",
                [
                  _c(
                    "v-form",
                    {
                      ref: "form",
                      attrs: { "lazy-validation": "" },
                      model: {
                        value: _vm.formValid,
                        callback: function($$v) {
                          _vm.formValid = $$v
                        },
                        expression: "formValid"
                      }
                    },
                    [
                      _c("multiple-user-select", {
                        attrs: {
                          "birth-date-required":
                            _vm.$store.getters["userProperties"].system_settings
                              .travel_service_hotel_insurance ===
                            _vm.insuranceTypeID.INSURANCE_ADD
                        }
                      }),
                      _c(
                        "v-row",
                        { attrs: { dense: "" } },
                        [
                          _c(
                            "v-col",
                            { staticClass: "pr-2", attrs: { cols: "6" } },
                            [
                              _c("v-select", {
                                attrs: {
                                  items: _vm.hotelTypes(),
                                  label: _vm.$t("travelService.roomType") + "*",
                                  rules: [_vm.validatorIsRequired]
                                },
                                model: {
                                  value:
                                    _vm.contextModel.travelServiceOrderItemHotel
                                      .room_type,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.contextModel
                                        .travelServiceOrderItemHotel,
                                      "room_type",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "contextModel.travelServiceOrderItemHotel.room_type"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { staticClass: "pl-2", attrs: { cols: "6" } },
                            [
                              _c("location-ajax-select", {
                                attrs: {
                                  label: _vm.$t("travelService.place") + "*",
                                  placeholder: _vm.$t(
                                    "travelService.enterCountry"
                                  ),
                                  rules: [
                                    function(v) {
                                      return (
                                        (v != null && v.length > 0) ||
                                        _vm.$t("global.error.required")
                                      )
                                    }
                                  ],
                                  "select-model":
                                    _vm.contextModel.travelServiceOrderItemHotel
                                      .place_id
                                },
                                on: {
                                  "update:selectModel": function($event) {
                                    return _vm.$set(
                                      _vm.contextModel
                                        .travelServiceOrderItemHotel,
                                      "place_id",
                                      $event
                                    )
                                  },
                                  "update:select-model": function($event) {
                                    return _vm.$set(
                                      _vm.contextModel
                                        .travelServiceOrderItemHotel,
                                      "place_id",
                                      $event
                                    )
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "v-row",
                        { attrs: { dense: "" } },
                        [
                          _c(
                            "v-col",
                            { staticClass: "pr-2", attrs: { cols: "6" } },
                            [
                              _c("date-picker", {
                                attrs: {
                                  label:
                                    _vm.$t("travelService.accommodationDate") +
                                    "*",
                                  max:
                                    _vm.contextModel.travelServiceOrderItemHotel
                                      .end_date,
                                  model:
                                    _vm.contextModel.travelServiceOrderItemHotel
                                      .start_date,
                                  rules: [
                                    _vm.validatorIsRequired,
                                    _vm.validatorIsFutureDate
                                  ]
                                },
                                on: {
                                  "update:model": function($event) {
                                    return _vm.$set(
                                      _vm.contextModel
                                        .travelServiceOrderItemHotel,
                                      "start_date",
                                      $event
                                    )
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { staticClass: "pl-2", attrs: { cols: "6" } },
                            [
                              _c(
                                "v-tooltip",
                                {
                                  attrs: { bottom: "" },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "activator",
                                      fn: function(ref) {
                                        var on = ref.on
                                        return [
                                          _c(
                                            "time-picker",
                                            _vm._g(
                                              {
                                                attrs: {
                                                  label: _vm.$t(
                                                    "travelService.accommodationTime"
                                                  ),
                                                  model:
                                                    _vm.contextModel
                                                      .travelServiceOrderItemHotel
                                                      .start_time,
                                                  placeholder: "14:00 - 18:00",
                                                  "prepend-icon":
                                                    "fa-info-circle",
                                                  clearable: ""
                                                },
                                                on: {
                                                  "update:model": function(
                                                    $event
                                                  ) {
                                                    return _vm.$set(
                                                      _vm.contextModel
                                                        .travelServiceOrderItemHotel,
                                                      "start_time",
                                                      $event
                                                    )
                                                  }
                                                }
                                              },
                                              on
                                            )
                                          )
                                        ]
                                      }
                                    }
                                  ])
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t(
                                          "travelService.accommodationHourTooltip"
                                        )
                                      ) +
                                      " "
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "v-row",
                        { attrs: { dense: "" } },
                        [
                          _c(
                            "v-col",
                            { staticClass: "pr-2", attrs: { cols: "6" } },
                            [
                              _c("date-picker", {
                                attrs: {
                                  label: _vm.$t("travelService.outDate") + "*",
                                  min:
                                    _vm.contextModel.travelServiceOrderItemHotel
                                      .start_date,
                                  model:
                                    _vm.contextModel.travelServiceOrderItemHotel
                                      .end_date,
                                  rules: [
                                    _vm.validatorIsRequired,
                                    _vm.validatorIsFutureDate
                                  ]
                                },
                                on: {
                                  "update:model": function($event) {
                                    return _vm.$set(
                                      _vm.contextModel
                                        .travelServiceOrderItemHotel,
                                      "end_date",
                                      $event
                                    )
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "6" } },
                            [
                              _c("v-checkbox", {
                                attrs: {
                                  label: _vm.$t(
                                    "travelService.isFreeCancellationRequired"
                                  )
                                },
                                model: {
                                  value:
                                    _vm.contextModel.travelServiceOrderItemHotel
                                      .is_free_cancellation,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.contextModel
                                        .travelServiceOrderItemHotel,
                                      "is_free_cancellation",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "contextModel.travelServiceOrderItemHotel.is_free_cancellation"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "v-row",
                        { attrs: { dense: "" } },
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "6" } },
                            [
                              _c("v-checkbox", {
                                attrs: { label: _vm.$t("global.breakfast") },
                                model: {
                                  value:
                                    _vm.contextModel.travelServiceOrderItemHotel
                                      .is_breakfast,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.contextModel
                                        .travelServiceOrderItemHotel,
                                      "is_breakfast",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "contextModel.travelServiceOrderItemHotel.is_breakfast"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "6" } },
                            [
                              _c("v-checkbox", {
                                attrs: {
                                  label: _vm.$t(
                                    "travelService.isParkingRequired"
                                  )
                                },
                                model: {
                                  value:
                                    _vm.contextModel.travelServiceOrderItemHotel
                                      .parking_required,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.contextModel
                                        .travelServiceOrderItemHotel,
                                      "parking_required",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "contextModel.travelServiceOrderItemHotel.parking_required"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c("v-checkbox", {
                        attrs: {
                          label: _vm.$t("travelService.additionalServices")
                        },
                        model: {
                          value:
                            _vm.contextModel.travelServiceOrderItemHotel
                              .is_additional_services,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.contextModel.travelServiceOrderItemHotel,
                              "is_additional_services",
                              $$v
                            )
                          },
                          expression:
                            "contextModel.travelServiceOrderItemHotel.is_additional_services"
                        }
                      }),
                      _vm.contextModel.travelServiceOrderItemHotel
                        .is_additional_services
                        ? _c("v-text-field", {
                            attrs: {
                              label: _vm.$t(
                                "travelService.additionalServicesDetails"
                              ),
                              placeholder: _vm.$t(
                                "travelService.additionalServicesPlaceholder"
                              ),
                              rules: [_vm.validatorIsRequired]
                            },
                            model: {
                              value:
                                _vm.contextModel.travelServiceOrderItemHotel
                                  .additional_services,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.contextModel.travelServiceOrderItemHotel,
                                  "additional_services",
                                  $$v
                                )
                              },
                              expression:
                                "contextModel.travelServiceOrderItemHotel.additional_services"
                            }
                          })
                        : _vm._e(),
                      _c(
                        "v-row",
                        { attrs: { dense: "" } },
                        [
                          _c(
                            "v-col",
                            { staticClass: "pr-2", attrs: { cols: "6" } },
                            [
                              _c("currency-select", {
                                attrs: {
                                  model:
                                    _vm.contextModel.travelServiceOrderItemHotel
                                      .currency
                                },
                                on: {
                                  "update:model": function($event) {
                                    return _vm.$set(
                                      _vm.contextModel
                                        .travelServiceOrderItemHotel,
                                      "currency",
                                      $event
                                    )
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { staticClass: "pl-2", attrs: { cols: "6" } },
                            [
                              _c("cost-centre-select", {
                                attrs: { value: _vm.contextModel.cost_centre },
                                on: {
                                  "update:value": function($event) {
                                    return _vm.$set(
                                      _vm.contextModel,
                                      "cost_centre",
                                      $event
                                    )
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c("v-text-field", {
                        attrs: { label: _vm.$t("global.comment") },
                        model: {
                          value: _vm.contextModel.comment,
                          callback: function($$v) {
                            _vm.$set(_vm.contextModel, "comment", $$v)
                          },
                          expression: "contextModel.comment"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "blue darken-1", text: "" },
                      nativeOn: {
                        click: function($event) {
                          return _vm.cancel($event)
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("global.cancel")))]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        disabled: !_vm.formValid,
                        color: "blue darken-1",
                        text: ""
                      },
                      nativeOn: {
                        click: function($event) {
                          return _vm.save($event)
                        }
                      }
                    },
                    [_vm._v("Ok")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }